import type { PetVaccinationSummary } from '@/lib/types';
import { cn } from '@/lib/utils';
import { Check, X } from 'lucide-react';

interface Props {
  vaccinations: PetVaccinationSummary[];
  className?: string;
}

export function VaccinePills({ vaccinations, className }: Props) {
  if (!vaccinations || vaccinations.length === 0) {
    return <p className={cn('text-xs text-muted-foreground', className)}>No vaccine records.</p>;
  }
  return (
    <div className={cn('flex flex-wrap gap-1.5', className)}>
      {vaccinations.map((v) => (
        <span
          key={v.id}
          className={cn(
            'inline-flex items-center gap-1.5 rounded-md px-2 py-0.5 text-[10.5px] font-medium ring-hairline',
            v.valid ? 'bg-success/10 text-success' : 'bg-destructive/10 text-destructive',
          )}
          title={v.expiresOn ? `Expires ${v.expiresOn}` : 'No expiry'}
        >
          {v.valid ? (
            <Check className="size-2.5" strokeWidth={3} />
          ) : (
            <X className="size-2.5" strokeWidth={3} />
          )}
          {v.vaccineName ?? v.vaccineId.slice(0, 8)}
          {v.expiresOn && <span className="num text-[9.5px] opacity-70">{v.expiresOn}</span>}
        </span>
      ))}
    </div>
  );
}
